import React, { Component } from 'react';
import Link  from '../components/link';
import Isvg from 'react-inlinesvg';
import Page from '../containers/page';


import {
    Container,
    Row,
    Col,
} from 'reactstrap';

import Slider from "react-slick";
import Image from '../components/image';

import downChevron from '../assets/svg/down-chevron.svg';
import moment from 'moment';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


class AboutUsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData
        };
    }

    componentDidMount() {

        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }


        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match).then((data) => {
                this.setState({
                    ...data
                })
            })
        }


    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.services && this.state.services) {
            new Slider(this.slider);
        }

        if (!prevState.latestBlog && this.state.latestBlog) {
            new Slider(this.newsSlider);
        }

    }


    render() {


        var settings3 = {
            infinite: true,
            speed: 500,
            slidesToShow: typeof window != 'undefined' && window.innerWidth < 768 ? 1 : 2,
            slidesToScroll: 1,
            dots: false,
            autoplay: true
          };

        return (
            <div className="about-us-wrap">
                <section className-name="el_MWt_UkcEbY" className="el_MWt_UkcEbY">
                    <div className-name="el_nxSTNAI73a" className="el_nxSTNAI73a container">
                        <div className-name="el_xXSSMBLR64" className="el_xXSSMBLR64 row">
                            <div className-name="el_CEQDddamsC" className="el_CEQDddamsC col-lg-12">
                                <h1 className-name="el_36aob6dvPA" className="el_36aob6dvPA">{'O nama'.translate(this.props.lang)}</h1>
                                <ul className-name="el_P3NocKyAEA" className="el_P3NocKyAEA">
                                    <li className-name="el_Jl1PjCRvxx" className="el_Jl1PjCRvxx">{'Početna'.translate(this.props.lang)}</li>
                                    <li className-name="el_Jl1PjCRvxx" className="el_Jl1PjCRvxx">{'O nama'.translate(this.props.lang)}</li>
                                </ul>
                            </div>

                            {
                                this.state.data && this.state.data.content && this.state.data.content.map((item, idx) => {
                                    if (item.type == 'image') {
                                        return (
                                            <Col lg={{ size: item.width.desktop }} xs={{ size: item.width.mobile }} className="block-section">
                                                <img src={item.value} />
                                            </Col>
                                        )
                                    } else {
                                        return (
                                            <Col lg={{ size: item.width.desktop }} xs={{ size: item.width.mobile }} className="block-section" dangerouslySetInnerHTML={{ __html: item.value && item.value[this.props.lang] }}>
                                            </Col>
                                        )
                                    }
                                })
                            }

                        </div></div></section>
                <section class-name="el_dUxKq53K63" className="el_dUxKq53K63" >
                    <div class-name="el_8icgJuauZp" className="el_8icgJuauZp container">
                        <div class-name="el_7HtZ5bRY4k" className="el_7HtZ5bRY4k row">
                            <div class-name="el_v7TayDmhAW" className="el_v7TayDmhAW col-lg-12">
                                <h6 class-name="el_v_SgQtCIq_" className="el_v_SgQtCIq_" >{'Aktuelnosti'.translate(this.props.lang)}</h6>
                                <h3 class-name="el_9y_mBE1znP" className="el_9y_mBE1znP"><span class-name="el_gNYVXPXPMv" className="el_gNYVXPXPMv">{'Novosti'.translate(this.props.lang)} </span> {'i obavještenja'.translate(this.props.lang)}</h3>
                                <p class-name="el_36X_1EeIlm" className="el_36X_1EeIlm">{'Aktuelnosti vezane za našu firmu'.translate(this.props.lang)}</p>
                            </div>
                            <div class-name="el_bMa2PoMVFB" className="el_bMa2PoMVFB col-lg-12">
                                <div id="slider_sYaGP" ref={(node) => this.newsSlider = node} slides-to-show="2" autoplay-speed="5000" class-name="el_pz3nbAiCTK" className="el_pz3nbAiCTK loaded"
                                    mobile-slides-to-show="1">
                                    <button className="button-control el_HOd_sYRbmk" control="prev" class-name="el_HOd_sYRbmk"
                                    ><svg xmlns="http://www.w3.org/2000/svg" width="9.414" height="16.829"
                                        viewBox="0 0 9.414 16.829">
                                            &nbsp; <path id="iconfinder_chevron-down_2561356" d="M0,7,7,0l7,7" transform="translate(1 15.414) rotate(-90)"
                                                fill="none" stroke="#1f1a16" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="2"></path>
                                        </svg>

                                    </button>
                                 
                                 <Slider {...settings3}>
                                            {
                                                this.state.latestBlog && this.state.latestBlog.map((item, idx) => {
                                                    return (
                                                        <article class-name="el_s_SzWof5q1" className="el_s_SzWof5q1 slider-item" clone="true">
                                                            <Link lang={this.props.lang} to={`/novosti/${Object.translate(item, 'alias', this.props.lang)}`}>  <img class-name="el_xSO39kUVy1" className="el_xSO39kUVy1" src={item.image} /> </Link>
                                                            <div class-name="el_7QHzULcE8O" className="el_7QHzULcE8O">
                                                                <div class-name="el_ujFQKxiIki" className="el_ujFQKxiIki">
                                                                    <p class-name="el_yLy6C_nuHV" className="el_yLy6C_nuHV">{moment.unix(item.timestamp).format('DD')}</p>
                                                                    <div class-name="el_47Qfk6MDfc" className="el_47Qfk6MDfc"></div>
                                                                    <p class-name="el_keLZ5Jwi1W" className="el_keLZ5Jwi1W">{moment.unix(item.timestamp).format('MMM YYYY')}</p>
                                                                </div>
                                                                <div class-name="el_RZ68j58P7w" className="el_RZ68j58P7w">
                                                                    <Link lang={this.props.lang} to={`/novosti/${Object.translate(item, 'alias', this.props.lang)}`}> <h6 class-name="el_Ab1FpyxUOn" className="el_Ab1FpyxUOn">{Object.translate(item, 'title', this.props.lang)}</h6></Link>
                                                                    <p class-name="el_wVA0h2JrGD" className="el_wVA0h2JrGD">{Object.translate(item, 'shortDescription', this.props.lang)}</p><Link lang={this.props.lang} class-name="el_xAyLrx9pbw"
                                                                        className="el_xAyLrx9pbw" to={`/novosti/${Object.translate(item, 'alias', this.props.lang)}`}>{'Detaljnije'.translate(this.props.lang)}</Link>
                                                                </div>
                                                            </div>
                                                        </article>

                                                    )
                                                })
                                            }
                                        
                                        </Slider>

                                      

                                    <button className="button-control el_gxLH002ENz" control="next" class-name="el_gxLH002ENz"
                                    ><svg xmlns="http://www.w3.org/2000/svg" width="9.414" height="16.829"
                                        viewBox="0 0 9.414 16.829">
                                            &nbsp; <path id="iconfinder_chevron-down_2561356" d="M6,9l7,7,7-7" transform="translate(-7.586 21.414) rotate(-90)"
                                                fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="2" class-name="el_x2Hwg9VaYO" className="el_x2Hwg9VaYO" ></path>
                                        </svg>

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class-name="el_L5yReJ6tMx" className="el_L5yReJ6tMx"><svg xmlns="http://www.w3.org/2000/svg"
                        width="695" height="395" viewBox="0 0 695 395">
                        &nbsp; <image id="pattern-11" width="695" height="395" href="data:image/png;base64,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"></image>
                    </svg>

                    </div>
                </section>
            </div>
        );
    }
}

export default Page(AboutUsPage);